import { MAX_MOTIVATION_LENGTH } from "@repo/contract/training";
import {
  "profile-editors.motivation_title" as motivationTitle,
  "intake.why.motivation.long" as motivationWhy,
  "profile-editors.motivation_placeholder" as placeholderText,
} from "@repo/i18n";
import { TextArea } from "../../../ui/controls";
import { Helper } from "./parts";

export interface MotivationFormProps {
  error?: string;
  onChange: (value: string) => void;
  value: string;
}

/**
 * The motivation. A2 offered six canned reasons; the contract stores one free
 * sentence (`D129`, at most 280 characters), so this is a text area with A2's
 * question. Empty clears it.
 */
export function MotivationForm({
  value,
  onChange,
  error,
}: MotivationFormProps) {
  return (
    <div>
      <Helper>{motivationWhy()}</Helper>
      <TextArea
        error={error}
        label={motivationTitle()}
        maxLength={MAX_MOTIVATION_LENGTH}
        onValueChange={onChange}
        placeholder={placeholderText()}
        rows={3}
        value={value}
      />
    </div>
  );
}
